/** Gemeinsame Zahlen- und Textwerte der Berichtsseiten (Zeiträume, Diagrammmaße, Darstellung). */

/** Obergrenze einer Prozentangabe. */
export const REPORT_PERCENT_MAX = 100;

/** Standardzeiträume der Berichte. */
export const REPORT_RANGE_MONTH_DAYS = 30;
export const REPORT_RANGE_QUARTER_DAYS = 90;
export const REPORT_RANGE_QUARTER_MONTHS = 3;
export const REPORT_RANGE_HALF_YEAR_MONTHS = 6;
export const REPORT_RANGE_YEAR_MONTHS = 12;

/** Linienstärken und Flächendeckkraft der Berichtsdiagramme. */
export const REPORT_CHART_PRIMARY_LINE_WIDTH = 3;
export const REPORT_CHART_SECONDARY_LINE_WIDTH = 2;
export const REPORT_CHART_AREA_OPACITY = 0.3;

/** Nachkommastellen für Beträge und Quoten in Kennzahlen. */
export const REPORT_DECIMAL_PLACES = 2;

/** Währungssymbol als Kennzahl-Suffix. */
export const REPORT_CURRENCY_SYMBOL = "€";
export const REPORT_CURRENCY_SUFFIX = ` ${REPORT_CURRENCY_SYMBOL}`;

/** Katalogschlüssel und -bezeichnungen der Berichtsgruppen, die an Mandantenmodule gebunden sind. */
export const REPORT_GROUP_KEY_CALENDAR = "calendar";
export const REPORT_GROUP_KEY_LEADS = "leads";
export const REPORT_GROUP_LABEL_CALENDAR = "Calendar";
export const REPORT_GROUP_LABEL_LEADS = "Leads & Sales";

/** Pfad des Artikelverkaufsberichts (nur mit Modul Artikelverkauf sichtbar). */
export const ARTICLE_SALES_REPORT_PATH = "/reports/finances/article-sales";
